import {
  IAIWorkspaceRequest,
  ICreatorScriptUserInputsPayload,
  IScriptGenerateCreator,
} from "@entities/aiWorkspace";
import {
  DEFAULT_SCRIPT_SETTINGS,
  SCRIPT_DURATIONS,
  SCRIPT_FORMATS,
  SCRIPT_LANGUAGES,
  SCRIPT_TONES,
  ScriptCreator,
  ScriptDraft,
  ScriptPlatform,
  matchedScriptOption,
} from "./types";

function asCreator(item: IScriptGenerateCreator): ScriptCreator | null {
  const profile = item.socialMedia;
  const job = item.creatorScriptGeneratorJob;
  const username = String(profile?.username || job?.username || "")
    .trim()
    .replace(/^@+/, "");
  const platform = String(
    profile?.platform || job?.platform || ""
  ).toLowerCase();
  const jobId = item.creatorScriptGeneratorJobId || job?._id || job?.id || "";
  // if (
  //   (platform !== "instagram" && platform !== "youtube") ||
  //   !username ||
  //   !jobId
  // )
  //   return null;
  return {
    id: item._id,
    jobId,
    platform: (platform as ScriptPlatform) || "",
    username: username || "",
    name: profile?.name?.trim() || username || "",
    image: profile?.profilePicUrl || undefined,
    followers: profile?.followers ?? profile?.searchV1?.followerCount,
  };
}

export function creatorsFromRequest(
  request?: IAIWorkspaceRequest
): ScriptCreator[] {
  if (!request || request.type !== "script-generate") return [];
  const seen = new Set<string>();
  const creators: ScriptCreator[] = [];
  for (const item of request.creatorScriptGenerations || []) {
    const creator = asCreator(item);
    if (!creator || seen.has(creator.id)) continue;
    seen.add(creator.id);
    creators.push(creator);
  }

  console.log("creators", creators, request.creatorScriptGenerations);
  return creators;
}

export function freshDraft(
  creator: ScriptCreator,
  brief: string,
  master?: ICreatorScriptUserInputsPayload
): ScriptDraft {
  const platformFormat = creator.platform === "youtube" ? "Video" : "Reel";
  return {
    id: creator.id,
    creator,
    brief: master?.brief?.trim() ? master.brief : brief,
    settings: {
      format: matchedScriptOption(master?.format, SCRIPT_FORMATS, platformFormat),
      duration: matchedScriptOption(
        master?.duration,
        SCRIPT_DURATIONS.map((item) => item.value),
        DEFAULT_SCRIPT_SETTINGS.duration
      ),
      tone: matchedScriptOption(master?.toneBalance, SCRIPT_TONES, DEFAULT_SCRIPT_SETTINGS.tone),
      language: matchedScriptOption(
        master?.language,
        SCRIPT_LANGUAGES,
        DEFAULT_SCRIPT_SETTINGS.language
      ),
    },
    markdown: "",
    status: "idle",
  };
}
